export enum Languages {
  PT_BR = 'pt-BR',
}
